export default __webpack_public_path__ + "static/media/404.dd34e759.png";